<template>
    <div class="pay">
        <div class="pay-form">
            <div class="form-title"><span>支付通道设置</span></div>
            <div class="select-form">
                <div class="select-title">您可以从以下两种方式中选择一种支付接入方式</div>
                <div class="select-item">
                    <el-radio v-model="payAccessMode" :label="1"></el-radio>
                    <span>方式一：接入共享充电平台支付结算中心</span>
                </div>
                <p>共享充电平台处理收单，结算和分账等工作，系统可以根据运营管理后台设置的分润比例对收入进行</p>
                <p class="add-btm">分账，站点收入从共享充电商户端提取。</p>
                <div class="select-item">
                    <el-radio v-model="payAccessMode" :label="2"></el-radio>
                    <span>方式二：接入自有支付方式</span>
                </div>
                <p>开发者填写微信/支付宝渠道支付参数，直接收款到开发者账户，系统无法根据运营管理后台设置的站</p>
                <p class="add-btm">点比例进行分账。适用于开发者自运营且不需要和场地方分润的站点。</p>
            </div>
            <div class="select-form" v-if="payAccessMode == 2">
                <div class="select-title">授权方式</div>
                <div class="select-item">
                    <el-radio v-model="payAuthMode" :label="1"></el-radio>
                    <span>填写支付请求地址</span>
                </div>
                <div>
                    <el-checkbox v-model="urlList.aliPay.checked">支付宝支付</el-checkbox>
                    <el-input v-model="urlList.aliPay.url" style="width: 360px;padding-bottom: 20px" size="small" :required="true">
                    </el-input>
                </div>
                <div>
                    <el-checkbox v-model="urlList.wechatPay.checked">微信支付</el-checkbox>
                    <el-input v-model="urlList.wechatPay.url" style="width: 360px;padding-bottom: 20px" size="small" :required="true">
                    </el-input>
                </div>
                <div>
                    <el-checkbox v-model="urlList.other.checked">其他支付</el-checkbox>
                    <el-input v-model="urlList.other.url" style="width: 360px;padding-bottom: 20px" size="small" :required="true">
                    </el-input>
                </div>
            </div>
        </div>
        <div class="pay-form" v-if="payAccessMode != 1">
            <div class="form-title"><span>积分支付配置  </span></div>
            <div class="radio">
                <label width="100" class="form-label">是否开通积分支付功能</label>
                <el-radio v-model="integralOpen" :label="1">开通</el-radio>
                <el-radio v-model="integralOpen" :label="0">不开通</el-radio>
            </div>
        </div>
        <div class="btn">
            <el-button type="primary" @click="submitPaySet">保存</el-button>
        </div>
    </div>
</template>
<script>
import {http, apiJson} from "@/utils/http"
import { Message } from 'element-ui';
export default {
    data () {
        return {
            payAccessMode: 1,
            payAuthMode: 1,
            integralOpen: 1,
            payType: '1',
            payAuthType: '1',
            payNotifyUrl: '',
            urlList: {
                aliPay: {
                    url: '',
                    checked: true
                },
                wechatPay: {
                    url: '',
                    checked: false
                },
                other: {
                    url: '',
                    checked: false
                }
            },
            payAuthParam: {},
            id: '',
            setParams: false
        };
    },
    created () {
        this.$store.dispatch('changeDefaultActive','pay')
        let {params} = this.$route
        this.getAppParam(params.id)
    },
    methods: {
        handelAdd () {
            if(this.urlList.length < 3) {
                this.urlList.push({
                    'url': '',
                    'select': 1
                })
            } else {
                Message.warning("最多三条")
            }
        },
        getAppParam (appId) {
            http(apiJson.getappparam, {appId}).then(res => {
                //console.log(res)
                if(res.code == 0 && res.data != "未查询到指定应用") {
                    this.setParams = true
                    this.getAppPay()
                }else if(res.code == 0) {
                    this.setParams = false
                    Message.warning("请先设置应用参数")
                }else {
                    this.$router.push("/login")
                }
            })
        },
        getAppPay () {
            let {params} = this.$route
            http(apiJson.getAppPay, {appId: params.id}).then(res => {
                if(res.code == 0) {
                    if (res.data != null && res.data.id) {
                        this.id = res.data.id
                        this.payAccessMode = res.data.payAccessMode
                        this.payAuthMode = res.data.payAuthMode
                        this.integralOpen = res.data.integralOpen
                        this.payNotifyUrl = res.data.payNotifyUrl
                        if(res.data.payAuthParam && res.data.payAuthParam.aliPay) {
                            this.urlList.aliPay = {
                                checked: true,
                                url: res.data.payAuthParam.aliPay.url
                            }
                        }
                        if(res.data.payAuthParam && res.data.payAuthParam.wechatPay) {
                            this.urlList.wechatPay = {
                                checked: true,
                                url: res.data.payAuthParam.wechatPay.url
                            }
                        }
                        if(res.data.payAuthParam && res.data.payAuthParam.other) {
                            this.urlList.other = {
                                checked: true,
                                url: res.data.payAuthParam.other.url
                            }
                        }
                    }
                }
            })
        },
        submitPaySet () {
            if(this.setParams) {
                if(this.payAccessMode == 2) {
                    if(this.urlList.aliPay.checked) {
                        if(this.urlList.aliPay.url) {
                            if(!/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(this.urlList.aliPay.url)) {
                                Message.warning("请填入正确格式的请求地址")
                                return
                            } else {
                                this.payAuthParam.aliPay = {
                                    payModes: 104,
                                    url: this.urlList.aliPay.url
                                }
                            }
                        } else {
                            Message.warning("请填入支付宝支付的请求地址")
                            return 
                        }
                    }
                    if(this.urlList.wechatPay.checked) { 
                        if(this.urlList.wechatPay.url) {
                            if(!/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(this.urlList.wechatPay.url)) {
                                Message.warning("请填入正确格式的请求地址")
                                return
                            } else {
                                this.payAuthParam.wechatPay = {
                                    payModes: 101,
                                    url: this.urlList.wechatPay.url
                                }
                            }
                        } else {
                            Message.warning("请填入微信支付的请求地址")
                            return 
                        } 
                    }
                    if(this.urlList.other.checked) {
                        if(this.urlList.other.url) {
                            if(!/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(this.urlList.other.url)) {
                                Message.warning("请填入正确格式的请求地址")
                                return
                            } else {
                                this.payAuthParam.other = {
                                    payModes: 110001,
                                    url: this.urlList.other.url
                                }
                            }
                        } else {
                            Message.warning("请填入其他支付的请求地址")
                            return 
                        }
                    }
                }
                if(this.payAccessMode == 2 && !this.urlList.aliPay.checked && !this.urlList.wechatPay.checked && !this.urlList.other.checked) {
                    Message.warning("请选择一项支付方式并填写请求地址")
                    return 
                }
                let {params} = this.$route
                let options = {
                    appId: params.id,
                    payAccessMode: this.payAccessMode,
                    payAuthMode: this.payAuthMode,
                    integralOpen: this.integralOpen,
                    payAuthType: parseInt(this.payAuthType),
                    payNotifyUrl: this.payNotifyUrl,
                    payAuthParam: this.payAuthParam
                }
                let url
                if(this.id) {
                    url = apiJson.updateAppPay
                    options.id = this.id
                } else {
                    url = apiJson.saveAppPay
                }
                http(url, options).then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.getAppPay()
                        Message.success(res.data)
                    } else {
                        Message.error('保存失败')
                    }
                })
            } else {
                Message.warning("请先设置应用参数")
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.pay {
    width: 100%;
    border-left: 1px solid #e5e5e5;
}
    .pay-form {
        width: 860px;
        margin: 0 auto;
        .form-title {
            padding-bottom: 10px;
            width: 100%;
            font-size: 16px;
            color: #666666;
            font-weight: bold;
            margin: 60px 0 30px;
            border-bottom: 1px solid #e5e5e5;
            span {
                padding-left: 14px;
                border-left: 4px solid #3296fa;
            }
        }
        .select-form {
            .select-title{
                font-size: 14px;
                color: #666666;
                padding-bottom: 21px;
            }
            .select-item {
                font-size: 14px;
                color: #333333;
                padding-bottom: 9px;
                span {
                    padding-left: 10px;
                }
            }
            p {
                line-height: 19px;
                font-size: 14px;
                color: #666666;
                padding-left: 30px;
            }
            .add-btm {
                padding-bottom: 20px;
            }
            .el-tabs {
                margin-top: -30px;
                & /deep/ .el-tabs__header {
                    width: 166px;
                    float: right;
                    height: 40px;
                }
                & /deep/ .el-tabs__content {
                    width: 860px;
                }
                & /deep/ .el-tab-pane {
                    width: 798px;
                    border: 1px solid #d6d6d6;
                    background: #f6f6f6;
                    border-radius: 4px;
                    padding: 20px 30px 0;
                    position: relative;
                    h4 {
                        font-size: 16px;
                        font-weight: normal;
                        color: #666666;
                        padding-bottom: 20px;
                        margin-bottom: 11px;
                        border-bottom: 1px solid #e5e5e5;
                    }
                    a {
                        color: #409EFF;
                        font-size: 12px;
                        position: absolute;
                        top: 24px;
                        right: 30px
                    }
                }
            }
        }
        
        >.radio {
            .el-radio {
                margin-top: 15px;
            }
            .form-label {
                float: left;
                display: block;
                width: 70px;
                height: 38px;
                line-height: 19px;
                font-size: 14px;
                color: #666666;
                margin-right: 20px;
            }
        }
    }
    .btn {
        width: 858px;
        border-top: 1px solid #e5e5e5;
        margin: 60px auto;
        padding-top: 20px;
        button {
            display: block;
            margin: 0 auto;
            width: 105px;
            height: 38px;
            line-height: 38px;
            padding: 0;
        }
    }
    .add {
        display: block;
        font-size: 14px;
        color: #2584ef;
        line-height: 19px;
        cursor: pointer;
    }
    .el-checkbox {
        width: 100px;
        padding-left: 30px; 
    }
</style>


// WEBPACK FOOTER //
// src/pages/CreateApp/pay.vue